import { CheckIcon, XIcon } from "./Icons";

export function BeforeAfter() {
    const before = [
        "Le téléphone sonne en plein coup de feu",
        "Erreurs de commande notées à la main",
        "Clients qui partent quand il y a la queue",
        "Pas de carte de fidélité, aucune donnée client",
        "Image artisanale mais pas professionnelle",
        "Impossible d'analyser ce qui se vend bien",
    ];
    const after = [
        "Les commandes arrivent automatiquement",
        "Zéro erreur — le client compose lui-même",
        "Les clients commandent avant d'arriver",
        "Fidélité automatique + promos ciblées",
        "Image pro — votre marque, votre app",
        "Analytics : ventes, produits populaires, etc.",
    ];

    return (
        <section className="py-12 px-6" id="avantages">
            <div className="text-center mb-12">
                <h2 className="text-[clamp(1.75rem,4vw,2.75rem)] font-extrabold text-slate-900 leading-[1.2] tracking-tight mb-4">
                    Sans commande en ligne vs. avec.
                </h2>
                <p className="text-[clamp(1.05rem,2vw,1.25rem)] text-slate-500 max-w-[680px] mx-auto leading-relaxed">
                    La différence au quotidien quand vos clients peuvent commander et payer depuis leur téléphone.
                </p>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto_1fr] gap-8 max-w-[960px] mx-auto items-stretch">
                {/* Sans */}
                <div className="rounded-2xl p-9 bg-red-50 border-2 border-red-200">
                    <h3 className="text-xl font-extrabold text-red-500 mb-5 flex items-center gap-2.5">
                        <XIcon size={22} className="text-red-500" /> Sans commande en ligne
                    </h3>
                    <ul className="list-none flex flex-col gap-3.5">
                        {before.map(item => (
                            <li key={item} className="flex items-start gap-2.5 text-[0.95rem] leading-relaxed">
                                <XIcon size={18} className="text-red-500 shrink-0 mt-0.5" /><span>{item}</span>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="flex items-center justify-center py-2 lg:py-0">
                    <div className="w-14 h-14 rounded-full bg-orange-500 text-white flex items-center justify-center text-[1.1rem] font-black shadow-[0_4px_14px_rgba(249,115,22,0.35)]">VS</div>
                </div>
                {/* Avec */}
                <div className="rounded-2xl p-9 bg-emerald-50 border-2 border-emerald-200">
                    <h3 className="text-xl font-extrabold text-emerald-500 mb-5 flex items-center gap-2.5">
                        <CheckIcon size={22} className="text-emerald-500" /> Avec votre appli de commande
                    </h3>
                    <ul className="list-none flex flex-col gap-3.5">
                        {after.map(item => (
                            <li key={item} className="flex items-start gap-2.5 text-[0.95rem] leading-relaxed">
                                <CheckIcon size={18} className="text-emerald-500 shrink-0 mt-0.5" /><span>{item}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}
